import Home from "./home";
import SpeaktoDoctor from './speakToDoctor'
import { useSelector } from "react-redux";
import { AppState } from "../state";
import { ApplicationPages } from "../state/features/applicationSlice";
import DoctorIntro from "./speakToDoctor/doctor";
import Start from "./speakToDoctor/start";
import Success from "./success";
import ServiceStart from "./bookServices/start";
import ServiceSuccess from "./success/ServiceSuccess";
import BookClassStart from "./bookClasses/start";
import BookingClassStepTwo from "./bookClasses/Step2";
import BookingClassSuccess from "./success/BookingClassSuccess";
import { Helmet } from 'react-helmet';
import { useEffect } from "react";
import Review from "./review";
import { Meta } from "../components/Meta";

export const Views = ({isPopUp}:{isPopUp: boolean}) => {
  const { activePage,activeFacility } = useSelector<AppState, AppState["application"]>(
    (state) => state.application
  );

  console.log('activePagesss', activePage)

  return (
    <div className="flex flex-col min-h-[700px] flex-1 h-full">
      <Meta title={"DrDoGood"} description={"Take Care"} />
      {activePage === ApplicationPages.HOME && <Home isPopUp={isPopUp}/>}
      {activePage === ApplicationPages.SPEAK_TO_DOCTOR && <SpeaktoDoctor />}
      {activePage === ApplicationPages.DOCTOR && <DoctorIntro />}
      {activePage === ApplicationPages.START && <Start />}
      {activePage === ApplicationPages.SUCCESS && <Success />}
      {activePage === ApplicationPages.BOOKING_CLASS_START && <BookClassStart />}
      {activePage === ApplicationPages.BOOKING_CLASS_STEP_TWO && <BookingClassStepTwo />}
      {activePage === ApplicationPages.REVIEW && <Review />}
      {activePage === ApplicationPages.BOOKING_CLASS_SUCCESS && <BookingClassSuccess />}

      {activePage === ApplicationPages.BOOKING_SERVICE_START && <ServiceStart />}
      {activePage === ApplicationPages.BOOKING_SERVICE_SUCCESS && <ServiceSuccess />}
    </div>
  );
};
